import { commonApi } from 'api';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';
import { useState } from 'react';
import { User } from 'types/api';

export const useFetchProfile = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [data, setData] = useState<User | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = async () => {
    setStatus('loading');
    try {
      const response = await commonApi.getUser();
      setData(response);
      setStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail);
      } else {
        setError('An error occurred');
      }
      setStatus('failed');
    }
  };

  return { status, data, error, fetchProfile };
};
